<template>
  <div class="rf-section">
    <div class="rf-section__header" @click="toggle">
      <span class="rf-section__chev" :class="{ open: !collapsed }">▸</span>
      <span class="rf-section__title">{{ title }}</span>
      <span class="rf-section__count">({{ count }})</span>
    </div>

    <transition name="rf-collapse">
      <div v-show="!collapsed" class="rf-section__body">
        <slot />
      </div>
    </transition>

    <div class="rf-section__separator"></div>
  </div>
</template>

<script>
export default {
  name: 'SectionGroup',
  props: {
    title: { type: String, default: '' },
    count: { type: Number, default: 0 },
    initiallyCollapsed: { type: Boolean, default: false },
  },
  data () {
    return { collapsed: this.initiallyCollapsed }
  },
  methods: {
    toggle () { this.collapsed = !this.collapsed },
  },
}
</script>

<style scoped>
.rf-section__header {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 6px 0;
}
.rf-section__chev {
  display: inline-block;
  transition: transform .15s ease;
  margin-right: 6px;
}
.rf-section__chev.open { transform: rotate(90deg); }
.rf-section__title { font-weight: 600; margin-right: 6px; }
.rf-section__count { color: #666; font-size: 12px; }
.rf-section__body { padding-left: 18px; }
.rf-section__separator { border-top: 1px solid #e6e6e6; margin: 10px 0 14px; }

.rf-collapse-enter-active, .rf-collapse-leave-active { transition: opacity .15s ease; }
.rf-collapse-enter, .rf-collapse-leave-to { opacity: 0; }
</style>
